<template>
  <section class="first">
    <div class="first--box">
      <!-- <div class="first--image">
        <div>
          <img src="@/assets/Personality/PersonalityTest/question.png" alt="" />
          <p>
            Fill the test questions with honest answers
          </p>
        </div>
        <div>
           <img src="@/assets/Personality/PersonalityTest/result.png" alt="" />
           <p>
             See your test result
           </p>
        </div>
        <div>
          <img src="@/assets/Personality/PersonalityTest/start.png" alt="" />
          <p>
            Start your career
          </p>
        </div>
      </div> -->
      <div class="first--question">
         <div class="bg">
      <img src="./bg.png" alt="">
    </div>
        <div class="test--question">
          <div class="test--question--text">
            <h3>Question 5 of 5</h3>
            <p>
              Far far away, behind the word mountains, far from the countries
              Vokalia and Consonantia, there live the blind texts.
            </p>
          </div>
          <div class="test--questions--box">
            <div
              v-for="question in questions"
              :key="question.id"
              class="test--questions--question"
            >
              <div class="check">
                <input
                  type="checkbox"
                  v-model="check"
                  :value="question.id"
                  id=""
                />
                <p>{{ question.id }}</p>
              </div>
              <div class="text">
                <h5>
                  {{ question.content }}
                </h5>
              </div>
            </div>
            <div class="btn">
               <button @click="handleSubmit" class="btn--course">Submit</button>
            </div>
            <div class="first--progressbar">
              <svg width="621" height="30" viewBox="0 0 621 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="22" width="621" height="8" rx="4" fill="#8F3D55"/>
<rect y="22" width="621" height="8" rx="4" fill="#B86B41"/>
<path d="M502.756 6.2C503.656 6.068 504.448 5.75 505.132 5.246H506.734V17H504.61V7.784C503.998 8.084 503.38 8.234 502.756 8.234V6.2ZM515.652 5.084C516.372 5.084 517.026 5.21 517.614 5.462C518.214 5.702 518.724 6.074 519.144 6.578C520.056 7.646 520.512 9.176 520.512 11.168C520.512 13.16 520.056 14.69 519.144 15.758C518.304 16.754 517.146 17.252 515.67 17.252C514.182 17.252 513.012 16.754 512.16 15.758C511.26 14.714 510.81 13.184 510.81 11.168C510.81 9.152 511.26 7.622 512.16 6.578C513.012 5.582 514.176 5.084 515.652 5.084ZM518.316 11.168C518.316 9.824 518.082 8.798 517.614 8.09C517.158 7.37 516.504 7.01 515.652 7.01C514.812 7.01 514.158 7.37 513.69 8.09C513.234 8.798 513.006 9.824 513.006 11.168C513.006 12.512 513.234 13.538 513.69 14.246C514.158 14.942 514.812 15.29 515.652 15.29C516.504 15.29 517.158 14.942 517.614 14.246C518.082 13.538 518.316 12.512 518.316 11.168ZM528.572 5.084C529.292 5.084 529.946 5.21 530.534 5.462C531.134 5.702 531.644 6.074 532.064 6.578C532.976 7.646 533.432 9.176 533.432 11.168C533.432 13.16 532.976 14.69 532.064 15.758C531.224 16.754 530.066 17.252 528.59 17.252C527.102 17.252 525.932 16.754 525.08 15.758C524.18 14.714 523.73 13.184 523.73 11.168C523.73 9.152 524.18 7.622 525.08 6.578C525.932 5.582 527.096 5.084 528.572 5.084ZM531.236 11.168C531.236 9.824 531.002 8.798 530.534 8.09C530.078 7.37 529.424 7.01 528.572 7.01C527.732 7.01 527.078 7.37 526.61 8.09C526.154 8.798 525.926 9.824 525.926 11.168C525.926 12.512 526.154 13.538 526.61 14.246C527.078 14.942 527.732 15.29 528.572 15.29C529.424 15.29 530.078 14.942 530.534 14.246C531.002 13.538 531.236 12.512 531.236 11.168ZM539.369 5.084C539.693 5.084 540.005 5.144 540.305 5.264C540.605 5.372 540.869 5.54 541.097 5.768C541.589 6.236 541.835 6.914 541.835 7.802C541.835 8.678 541.589 9.362 541.097 9.854C540.641 10.31 540.059 10.538 539.351 10.538C538.667 10.538 538.097 10.31 537.641 9.854C537.149 9.362 536.903 8.678 536.903 7.802C536.903 6.914 537.149 6.236 537.641 5.768C538.109 5.312 538.685 5.084 539.369 5.084ZM540.233 7.802C540.233 6.89 539.939 6.434 539.351 6.434C538.775 6.434 538.487 6.89 538.487 7.802C538.487 8.726 538.775 9.188 539.351 9.188C539.939 9.188 540.233 8.726 540.233 7.802ZM545.633 5.318H547.775L539.873 17H537.713L545.633 5.318ZM546.119 11.78C546.803 11.78 547.379 12.008 547.847 12.464C548.339 12.932 548.585 13.61 548.585 14.498C548.585 15.386 548.339 16.076 547.847 16.568C547.391 17.024 546.815 17.252 546.119 17.252C545.423 17.252 544.847 17.024 544.391 16.568C543.899 16.076 543.653 15.386 543.653 14.498C543.653 13.61 543.899 12.932 544.391 12.464C544.859 12.008 545.435 11.78 546.119 11.78ZM546.119 13.13C545.543 13.13 545.255 13.592 545.255 14.516C545.255 15.428 545.543 15.884 546.119 15.884C546.371 15.884 546.581 15.782 546.749 15.578C546.917 15.362 547.001 15.008 547.001 14.516C547.001 14.012 546.917 13.658 546.749 13.454C546.581 13.238 546.371 13.13 546.119 13.13ZM562.635 5.318C564.411 5.318 565.845 5.846 566.937 6.902C568.041 7.958 568.593 9.38 568.593 11.168C568.593 12.944 568.041 14.36 566.937 15.416C565.845 16.472 564.411 17 562.635 17H558.837V5.318H562.635ZM560.979 15.074H562.635C563.739 15.074 564.633 14.702 565.317 13.958C565.965 13.238 566.289 12.308 566.289 11.168C566.289 10.004 565.965 9.062 565.317 8.342C564.645 7.61 563.751 7.244 562.635 7.244H560.979V15.074ZM577.207 5.084C577.987 5.084 578.701 5.216 579.349 5.48C579.997 5.732 580.555 6.11 581.023 6.614C582.007 7.67 582.499 9.182 582.499 11.15C582.499 13.13 582.007 14.66 581.023 15.74C580.087 16.748 578.809 17.252 577.189 17.252C575.581 17.252 574.309 16.736 573.373 15.704C572.389 14.636 571.897 13.118 571.897 11.15C571.897 9.158 572.389 7.634 573.373 6.578C574.297 5.582 575.575 5.084 577.207 5.084ZM580.303 11.186C580.303 9.842 580.021 8.81 579.457 8.09C578.905 7.358 578.155 6.992 577.207 6.992C576.259 6.992 575.503 7.358 574.939 8.09C574.375 8.81 574.093 9.842 574.093 11.186C574.093 12.518 574.375 13.544 574.939 14.264C575.503 14.972 576.259 15.326 577.207 15.326C578.155 15.326 578.905 14.972 579.457 14.264C580.021 13.544 580.303 12.518 580.303 11.186ZM588.828 5.318L593.976 13.598V5.318H596.1V17H593.94L588.63 8.432V17H586.506V5.318H588.828ZM600.957 5.318H608.481V7.154H603.081V10.232H608.139V12.068H603.081V15.146H608.481V17H600.957V5.318Z" fill="black"/>
</svg>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div>
    
  </div>
</template>

<script>
export default {
  props: {
    count: {
      required: true,
      type: Number
    }
  },
  mounted() {
    window.scrollTo(0,0)
  },
  methods: {
    handleSubmit() {
      this.$emit('updateCount', 3)
    }
  },
  data() {
    return {
      check: [],
      questions: [
        {
          id: "a.",
          content:
            "Even the all-powerful Pointing has no control about the blind texts",
        },
        {
          id: "b.",
          content:
            "Even the all-powerful Pointing has no control about the blind texts",
        },
        {
          id: "c.",
          content:
            "Even the all-powerful Pointing has no control about the blind texts",
        },
        {
          id: "d.",
          content:
            "Even the all-powerful Pointing has no control about the blind texts",
        },
        {
          id: "e.",
          content:
            "Even the all-powerful Pointing has no control about the blind texts",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/TestStyle/Test.scss";
</style>